import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiRequestParams,
  OpalApiResponseDocument,
} from '../../schema'

export const read = async (
  params: OpalApiRequestParams<'ReadBulkOperationV3'>
): Promise<OpalApiResponseDocument<'ReadBulkOperationV3', 200>> => {
  const url = new URL(
    `/v3/bulk_operations/${params.path.bulk_operation_id}`,
    window.location.origin
  )

  url.search = queryString(params?.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
